// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_hie","tabsBox":"styles_tabsBox__mhSNu","createButton":"styles_createButton__I_QNe"};